/**
 * Camions dont le chargement roule encore (« Camions en cours de chargement »
 * de l'écran Stock).
 *
 * `/stock/summary` groupe ses mouvements par trajet (`by_truck`), avec les
 * litres importés et les litres encore en transit, mais sans la plaque. Un
 * trajet déjà soldé (plus rien en transit) n'a rien à faire dans cette liste:
 * l'écran l'annonçait « 45 000 L en transit » sous « Camion non identifié ».
 * Ici, seuls les trajets qui ont encore des litres en route restent, et la
 * plaque est retrouvée par le trajet puis le camion.
 */
const texte = (v) => {
  const t = v === null || v === undefined ? '' : String(v).trim();
  return t && !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(t) ? t : '';
};

/**
 * Le camion d'une ligne (mouvement ou regroupement du résumé): d'abord son
 * propre `truck_id`, sinon le camion du trajet, sinon les plaques portées par
 * le trajet. Rend « tracteur · citerne », ou, quand aucun lien n'existe, la
 * référence du trajet (jamais un identifiant).
 */
export const libelleCamion = ({ truckId, trajet, camions = [], matricule } = {}) => {
  const camion = (truckId && (camions || []).find((c) => c && c.id === truckId))
    || (trajet?.truck_id && (camions || []).find((c) => c && c.id === trajet.truck_id))
    || null;
  const tracteur = texte(matricule) || texte(camion?.matricule) || texte(trajet?.tractor_plate) || texte(trajet?.truck_matricule);
  const citerne = texte(camion?.tank_number) || texte(trajet?.tank_plate);
  if (tracteur) return [tracteur, citerne && citerne !== tracteur ? citerne : ''].filter(Boolean).join(' · ');
  if (citerne) return citerne;
  const reference = texte(trajet?.reference) || texte(trajet?.trip_number);
  return reference ? `Camion non identifié · trajet ${reference}` : 'Camion non identifié';
};

export const camionsEnTransit = (parCamion, trajets = [], camions = []) => {
  if (!Array.isArray(parCamion)) return [];
  const trajetParId = new Map((trajets || []).filter(Boolean).map((t) => [t.id, t]));
  return parCamion
    .filter((ligne) => Number(ligne?.in_transit_liters) > 0)
    .map((ligne) => ({
      ...ligne,
      libelle: libelleCamion({
        truckId: ligne.truck_id,
        matricule: ligne.matricule,
        trajet: trajetParId.get(ligne.trip_id),
        camions,
      }),
    }));
};
